import type { TAiFindingPriority, TAiFindingStatusTone } from './types';

export const AI_FINDINGS_SIDEBAR_WIDTH_PX = 300;
export const AI_FINDINGS_LOADING_DURATION_MS = 5000;
export const AI_FINDINGS_LOADING_STEPS = [
  'Reviewing document...',
  'Scanning document for inconsistencies...',
  'Cross-checking requirements and related documents...',
  'Analyzing traceability and document coverage...',
  'Evaluating content consistency...',
  'Identifying hidden gaps in the document...',
] as const;
export const AI_FINDINGS_LOADING_PROGRESS_CHECKPOINTS = [
  { time: 0, value: 0.02 },
  { time: 0.07, value: 0.05 },
  { time: 0.16, value: 0.11 },
  { time: 0.29, value: 0.28 },
  { time: 0.38, value: 0.34 },
  { time: 0.51, value: 0.57 },
  { time: 0.61, value: 0.63 },
  { time: 0.73, value: 0.8 },
  { time: 0.84, value: 0.86 },
  { time: 0.93, value: 0.94 },
  { time: 1, value: 1 },
] as const;

export const AI_FINDING_PRIORITY_META: Record<
  TAiFindingPriority,
  { label: string; badgeColor: 'danger' | 'warning' | 'informative' }
> = {
  critical: {
    label: 'Critical',
    badgeColor: 'danger',
  },
  warning: {
    label: 'Warning',
    badgeColor: 'warning',
  },
  info: {
    label: 'Info',
    badgeColor: 'informative',
  },
};

export const AI_FINDING_STATUS_META: Record<TAiFindingStatusTone, { badgeColor: TAiFindingStatusTone }> = {
  danger: {
    badgeColor: 'danger',
  },
  warning: {
    badgeColor: 'warning',
  },
  informative: {
    badgeColor: 'informative',
  },
};
